export default  {
  template: require('../views/logoIcon.html')
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/logoIcon.component.js